import {
  getDataFromLink,
  fallbackText,
  Prismic,
  PrismicLink,
  PrismicText,
} from '@landsbankinn/prismic';
import { Button, Segment, theme } from '@landsbankinn/ui';
import React from 'react';
import { BecomeACustomer } from '../components/become-a-customer/BecomeACustomer';

interface IProps {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  background: string;
  link_text?: Prismic.RichText;
  link?: Prismic.Link;
  images: IImages[];
}

interface IImages {
  image: Prismic.Image;
}

export const BecomeACustomerContainer = ({
  title,
  copy,
  background,
  link_text,
  link,
  images,
}: IProps) => {
  const buttonLinkdata = getDataFromLink(link);
  const buttonTitle = fallbackText(
    link_text as any,
    buttonLinkdata.title ?? undefined,
  );
  const randomImage = images?.length
    ? images[Math.floor(Math.random() * images.length)]?.image
    : null;

  const action = link ? (
    <PrismicLink value={link} title={buttonTitle ?? undefined}>
      <Button
        as="a"
        bg={theme.colors.secondary}
        title={buttonTitle ?? undefined}
        icon={
          <svg width="16" height="9" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fillRule="evenodd">
              <path
                d="M6.841-.012l9 4.5-9 4.5V4.987H.207v-1h6.634v-4z"
                fill="currentColor"
                fillRule="nonzero"
              />
            </g>
          </svg>
        }
      />
    </PrismicLink>
  ) : null;
  return (
    <Segment>
      <BecomeACustomer
        title={Prismic.text(title) ?? ''}
        copy={<PrismicText value={copy} />}
        action={action}
        image={randomImage ?? undefined}
      />
    </Segment>
  );
};
